import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch, Redirect } from 'react-router-dom';
import Loader from './components/Loader';

function SpinningIcon({ pastDelay }) {
  if (pastDelay) {
    return <Loader fixed={true} />;
  }
  return null;
}

// const Welcome = Loadable({
//   loader: () =>
//     import(/* webpackChunkName: 'welcome' */ "./pages/auth/Welcome"),
//   loading: SpinningIcon,
//   delay: 300,
// });

const Login = Loadable({
  loader: () => import(/* webpackChunkName: 'login' */ './pages/auth/Login'),
  loading: SpinningIcon,
  delay: 300,
});

const Registration = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'registration' */ './pages/auth/Registration'),
  loading: SpinningIcon,
  delay: 300,
});

// const DeliveryAddress = Loadable({
//   loader: () =>
//     import(
//       /* webpackChunkName: 'deliveryaddress' */ "./pages/settings/DeliveryAddress"
//     ),
//   loading: SpinningIcon,
//   delay: 300,
// });

const Store = Loadable({
  loader: () => import(/* webpackChunkName: 'store' */ './pages/store/Store'),
  loading: SpinningIcon,
  delay: 300,
});
const Checkout = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'checkout' */ './pages/store/Checkout'),
  loading: SpinningIcon,
  delay: 300,
});
const Messages = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'message' */ './pages/messages/Messages'),
  loading: SpinningIcon,
  delay: 300,
});

const Menu = Loadable({
  loader: () => import(/* webpackChunkName: 'Menu' */ './pages/menu/Menu'),
  loading: SpinningIcon,
  delay: 300,
});

const Inbox = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Inbox' */ './pages/messages/Inbox'),
  loading: SpinningIcon,
  delay: 300,
});
const Cart = Loadable({
  loader: () => import(/* webpackChunkName: 'Cart' */ './pages/store/Cart.js'),
  loading: SpinningIcon,
  delay: 300,
});

const Orders = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Orders' */ './pages/orders/Orders'),
  loading: SpinningIcon,
  delay: 300,
});
const InviteRetailers = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'InviteRetailers' */ './pages/menu/InviteRetailers'
    ),
  loading: SpinningIcon,
  delay: 300,
});
const StoreProfile = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StoreProfile' */ './pages/menu/StoreProfile'),
  loading: SpinningIcon,
  delay: 300,
});
const UserProfile = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StoreProfile' */ './pages/menu/UserProfile'),
  loading: SpinningIcon,
  delay: 300,
});
const UpdateUserProfile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'StoreProfile' */ './pages/menu/UpdateUserProfile'
    ),
  loading: SpinningIcon,
  delay: 300,
});
const MyWallet = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StoreProfile' */ './pages/menu/MyWallet'),
  loading: SpinningIcon,
  delay: 300,
});
const UpdateStoreProfile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'StoreProfile' */ './pages/menu/UpdateStoreProfile'
    ),
  loading: SpinningIcon,
  delay: 300,
});

const Promotions = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StoreProfile' */ './pages/store/Promotions'),
  loading: SpinningIcon,
  delay: 300,
});
const ClearanceSales = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'StoreProfile' */ './pages/store/ClearanceSales'
    ),
  loading: SpinningIcon,
  delay: 300,
});

const OrderDetails = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'orderDetails' */ './pages/orders/OrderDetails'
    ),
  loading: SpinningIcon,
  delay: 300,
});
const Invoice = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'invoice' */ './pages/orders/Invoice'),
  loading: SpinningIcon,
  delay: 300,
});

const MyAccount = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'myAccount' */ './pages/account/MyAccount'),
  loading: SpinningIcon,
  delay: 300,
});
const ProfilePromotion = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'profilePromotion' */ './pages/account/ProfilePromotion'
    ),
  loading: SpinningIcon,
  delay: 300,
});
const ChangePassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'changePassword' */ './pages/menu/ChangePassword'
    ),
  loading: SpinningIcon,
  delay: 300,
});
const DeleteAccount = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'changePassword' */ './pages/menu/DeleteAccount'
    ),
  loading: SpinningIcon,
  delay: 300,
});

function Router(props) {
  const customerStatus = props.customerStatus;
  return (
    <div className="app__router">
      {customerStatus === 'phoneAndAddressAdded' ? (
        <Switch>
          <Route
            exact
            path="/messages/inbox"
            render={props => (
              <Inbox {...props} prevPage={'/messages'} title={'Inbox'} />
            )}
          />

          <Route
            exact
            path="/promotions/:id"
            render={props => <Promotions {...props} prevPage={'/store'} />}
          />

          <Route
            exact
            path="/profile/promotions/:id"
            render={props => (
              <ProfilePromotion
                {...props}
                title={'Profile Promotion'}
                prevPage={'/account'}
              />
            )}
          />
          <Route
            exact
            path="/promo-Product/:id"
            render={props => (
              <ClearanceSales
                {...props}
                prevPage={'/store'}
              />
            )}
          />

          <Route
            exact
            path="/menu/change-password"
            render={props => (
              <ChangePassword
                {...props}
                prevPage={'/menu'}
                title={'Change Password'}
              />
            )}
          />

          <Route
            exact
            path="/delete-account"
            render={props => (
              <DeleteAccount {...props} title={'Delete account'} />
            )}
          />

          <Route
            exact
            path="/menu/wallet"
            render={props => (
              <MyWallet {...props} prevPage={'/menu'} title={'My Wallet'} />
            )}
          />
          <Route
            exact
            path="/update-store"
            render={props => (
              <UpdateStoreProfile
                {...props}
                prevPage={'/menu/store-profile'}
                title={'Update Store'}
              />
            )}
          />
          <Route
            exact
            path="/update-profile"
            render={props => (
              <UpdateUserProfile
                {...props}
                prevPage={'/menu/user-profile'}
                title={'Update Profile'}
              />
            )}
          />

          <Route
            exact
            path="/menu/invite-retailers"
            render={props => (
              <InviteRetailers
                {...props}
                prevPage={'/menu'}
                title={'Invite Retailers'}
              />
            )}
          />

          <Route exact path="/">
            <Redirect to="/store" />
          </Route>
          <Route
            exact
            path="/checkout"
            render={props => (
              <Checkout {...props} title={'Checkout'} prevPage={'/cart'} />
            )}
          />
          <Route
            exact
            path="/cart"
            render={props => (
              <Cart {...props} title={'Cart'} prevPage={'/store'} />
            )}
          />

          <Route
            exact
            path="/menu"
            render={props => <Menu {...props} title={'Menu'} />}
          />

          <Route
            exact
            path="/orders"
            render={props => (
              <Orders {...props} prevPage={'/account'} title={'Orders'} />
            )}
          />

          <Route
            exact
            path="/menu/store-profile"
            render={props => (
              <StoreProfile
                {...props}
                prevPage={'/menu'}
                title={'Store Profile'}
              />
            )}
          />
          <Route
            exact
            path="/menu/user-profile"
            render={props => (
              <UserProfile
                {...props}
                prevPage={'/menu'}
                title={'User Profile'}
              />
            )}
          />

          <Route
            exact
            path="/account"
            render={props => <MyAccount {...props} title={'My Account'} />}
          />

          <Route
            exact
            path="/messages"
            render={props => <Messages {...props} title={'Messages'} />}
          />

          <Route
            exact
            path="/store"
            render={props => <Store {...props} title={'Store'} />}
          />

          <Route
            exact
            path="/orders/details/:id"
            render={props => (
              <OrderDetails
                {...props}
                title={'Order Details'}
                prevPage={'/orders'}
              />
            )}
          />
          <Route
            exact
            path="/invoice/:id"
            render={props => (
              <Invoice {...props} title={'Invoice'} prevPage={'/store'} />
            )}
          />

          <Route render={() => <Redirect to="/store" />} />
        </Switch>
      ) : (
        <Switch>
          <Route
            exact
            path="/login"
            render={props => <Login {...props} title={'Login'} />}
          />
          <Route exact path="/registration">
            <Redirect from="/registration" to="/registration/contact-details" />
          </Route>
          <Route exact path="/register">
            <Redirect from="/register" to="/registration/contact-details" />
          </Route>
          <Route exact path="/registration/business-profile">
            <Redirect
              from="/registration/business-profile"
              to="/registration/contact-details"
            />
          </Route>
          <Route
            exact
            path="/registration/:formStep"
            render={props => (
              <Registration
                {...props}
                prevPage={'/login'}
                title={'Registration'}
              />
            )}
          />
          <Route
            exact
            path="/delete-account"
            render={props => (
              <DeleteAccount {...props} title={'Delete account'} />
            )}
          />

          <Route render={() => <Redirect to="/login" />} />
        </Switch>
      )}
    </div>
  );
}

export default Router;
